"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _DateHelper = _interopRequireDefault(require("../../../../../../util/DateHelper"));

var _CardModel = _interopRequireDefault(require("../../../../../../modules/cards/models/CardModel"));

var _index = require("../../../../../../index");

var _Radio = _interopRequireDefault(require("@material-ui/core/Radio"));

var _RadioGroup = _interopRequireDefault(require("@material-ui/core/RadioGroup"));

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _AppSelect = _interopRequireDefault(require("../../../../../../components/crud/AppSelect"));

var _UserModel = _interopRequireDefault(require("../../../models/UserModel"));

var _AppNumberField = _interopRequireDefault(require("../../../../../../components/elements/form/AppNumberField"));

var _DeleteButton = _interopRequireDefault(require("../../../../../../components/crud/DeleteButton"));

var _components = require("../../../../../../components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CustomerBasicInfo = /*#__PURE__*/function (_Component) {
  _inherits(CustomerBasicInfo, _Component);

  function CustomerBasicInfo(props) {
    var _this;

    _classCallCheck(this, CustomerBasicInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CustomerBasicInfo).call(this, props)); // Initial state

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      _this.setState({
        radioValue: event.target.value
      });
    });

    _this.formHandler = new _index.FormHandler(_assertThisInitialized(_this), new _CardModel["default"]({
      charge: '',
      pin: '',
      pinFromCard: ''
    }), {
      showReissueModal: false,
      showInfoModal: false,
      radioValue: '',
      cards: null,
      cardId: [],
      redirect: false
    });
    return _this;
  }

  _createClass(CustomerBasicInfo, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var id = this.props.user.id;

      if (id) {
        this._pullCards(id);
      }
    }
  }, {
    key: "_pullCards",
    value: function _pullCards(id) {
      var _this2 = this;

      new _UserModel["default"]().getCards(id).then(function (result) {
        _this2.setState({
          record: result,
          cards: result
        });
      });
    }
  }, {
    key: "onCloseReissue",
    value: function onCloseReissue() {
      this.setState({
        showReissueModal: false,
        radioValue: ''
      });
    }
  }, {
    key: "openReissueModal",
    value: function openReissueModal() {
      this.setState({
        showReissueModal: true
      });
    }
  }, {
    key: "listCards",
    value: function listCards() {
      var cards = this.state.cards;
      var ccc = [];

      if (cards) {
        cards.forEach(function (c, index) {
          ccc.push(c.id);
        });
        return ccc;
      }
    }
  }, {
    key: "onCloseInfoModal",
    value: function onCloseInfoModal() {
      this.setState({
        showInfoModal: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var user = this.props.user;
      var formHandler = this.formHandler;

      if (this.state.redirect) {
        return _react["default"].createElement(_reactRouterDom.Redirect, {
          to: "/users/all-users/details/".concat(user.id)
        });
      }

      this.listCards();
      var kycStatus = user.kycStatus || '';
      var newKycStatus = kycStatus.replace(/#|_/g, ' ');
      return _react["default"].createElement("div", {
        className: "main"
      }, _react["default"].createElement(_components.LPOverridable, {
        name: "user.details.beforeContent",
        cards: this.state.cards,
        user: user,
        refresh: function refresh() {
          _this3.props.fetcher.refresh();

          _this3._pullCards(user.id);
        }
      }), _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "customers-info"
      }, _react["default"].createElement("div", {
        className: "customer-details"
      }, _react["default"].createElement("div", null, _react["default"].createElement("h2", {
        className: "customer-name"
      }, _react["default"].createElement("span", {
        className: "company"
      }, user.fullName))), _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "bottom",
        style: {
          alignItems: 'center'
        }
      }, _react["default"].createElement(_reactRouterDom.Link, {
        to: "/users/all-users/edit-user/".concat(user.id),
        className: "button-info",
        style: {
          marginRight: 20
        }
      }, "Edit")))), _react["default"].createElement("div", {
        className: "customers-main"
      }, _react["default"].createElement("div", {
        className: "row"
      }, _react["default"].createElement("div", {
        className: "col"
      }, _react["default"].createElement("div", {
        className: "padded"
      }, _react["default"].createElement("div", {
        className: "row text-white"
      }, _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        },
        className: "col-lg-6"
      }, _react["default"].createElement("h4", null, "Basic Info"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "First name:"), _react["default"].createElement("dd", null, user.firstName), _react["default"].createElement("dt", null, "Last name:"), _react["default"].createElement("dd", null, user.lastName), _react["default"].createElement("dt", null, "E-mail address:"), _react["default"].createElement("dd", null, user.email), _react["default"].createElement("dt", null, "Birth date:"), _react["default"].createElement("dd", null, _DateHelper["default"].date(user.birthDate, 'D / MMMM / Y')))), _react["default"].createElement("div", {
        className: "col-lg-6"
      }, _react["default"].createElement("div", {
        style: {
          maxWidth: 200,
          margin: 'auto 0 auto auto'
        }
      }, _react["default"].createElement(_DeleteButton["default"], {
        block: true,
        onConfirm: function onConfirm() {
          return _this3.onResetPassword(user.email);
        },
        text: 'New password will be sent to user email.  Are you sure?',
        btnText: 'Reset password'
      })))), _react["default"].createElement("div", {
        className: "row text-white"
      }, _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        },
        className: "col-lg-6"
      }, _react["default"].createElement("h4", null, "Address Info"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "Address Line One:"), _react["default"].createElement("dd", null, user.addressOne), _react["default"].createElement("dt", null, "Address Line Two:"), _react["default"].createElement("dd", null, user.addressTwo), _react["default"].createElement("dt", null, "City:"), _react["default"].createElement("dd", null, user.city), _react["default"].createElement("dt", null, "Postcode:"), _react["default"].createElement("dd", null, user.postCode), _react["default"].createElement("dt", null, "Country:"), _react["default"].createElement("dd", null, user.countryName), _react["default"].createElement("dt", null, "Mobile:"), _react["default"].createElement("dd", null, user.mobile))), _react["default"].createElement("div", {
        style: {
          marginBottom: 20
        },
        className: "col-lg-6"
      }, _react["default"].createElement("h4", null, "KYC"), _react["default"].createElement("hr", null), _react["default"].createElement("dl", null, _react["default"].createElement("dt", null, "Status:"), _react["default"].createElement("dd", null, newKycStatus.toUpperCase())), _react["default"].createElement("div", {
        style: {
          maxWidth: 200,
          margin: 'auto 0 auto auto'
        }
      }, user.kycStatus === 'approved' ? _react["default"].createElement(_DeleteButton["default"], {
        btnText: 'Reject',
        block: true,
        onConfirm: function onConfirm() {
          return _this3.onRejectUser(user.id);
        },
        text: 'Are you sure you wish to reject this user "' + user.fullName + '"?'
      }) : _react["default"].createElement(_DeleteButton["default"], {
        btnText: 'Approve',
        block: true,
        onConfirm: function onConfirm() {
          return _this3.onApproveUser(user.id);
        },
        text: 'Are you sure you wish to approve this user "' + user.fullName + '"?'
      }))))))))), _react["default"].createElement(_index.ModalDialog, {
        show: this.state.showReissueModal,
        onClose: this.onCloseReissue.bind(this)
      }, _react["default"].createElement("div", {
        style: {
          padding: '20px 0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          background: '#b74343'
        }
      }, _react["default"].createElement("span", {
        style: {
          color: 'white',
          borderBottom: '1px solid white',
          width: '70%',
          textAlign: 'center',
          paddingBottom: 15,
          fontSize: 24
        }
      }, "Reissue card"), _react["default"].createElement("div", {
        className: "add-new-group",
        style: {
          position: 'relative'
        }
      }, _react["default"].createElement("div", {
        className: "container"
      }, _react["default"].createElement(_index.FormSubmitWrapper, {
        formHandler: formHandler,
        to: '/users/all-users/details/' + user.id
      }, _react["default"].createElement("span", {
        style: {
          color: 'white'
        }
      }, "PIN selection"), _react["default"].createElement("div", {
        style: {
          border: '1px solid white',
          padding: '0 20px'
        }
      }, _react["default"].createElement(_RadioGroup["default"], {
        value: this.state.radioValue,
        onChange: this.handleChange
      }, _react["default"].createElement(_FormControlLabel["default"], {
        value: "manual",
        control: _react["default"].createElement(_Radio["default"], {
          color: "primary"
        }),
        label: "Manual selection"
      }), _react["default"].createElement(_FormControlLabel["default"], {
        value: "fromCard",
        control: _react["default"].createElement(_Radio["default"], {
          color: "primary"
        }),
        label: "Copy from old card"
      }), "/>"), this.state.radioValue === 'manual' ? _react["default"].createElement(_AppNumberField["default"], {
        format: "# # # #",
        placeholder: " * * * * ",
        mask: "*",
        label: "Pin",
        type: "tel",
        name: "pin",
        value: this.state.record.pin,
        handler: formHandler
      }) : null, this.state.radioValue === 'fromCard' ? _react["default"].createElement(_AppSelect["default"], {
        textFieldProps: {
          label: 'Pin from ID',
          InputLabelProps: {
            shrink: true
          }
        },
        options: this.state.cards,
        name: "pinFromCard",
        value: this.listCards(),
        handler: formHandler,
        placeholder: "Search a Card ID"
      }) : null), _react["default"].createElement("div", {
        style: {
          border: '1px solid white',
          padding: '0 20px',
          marginTop: 10
        }
      }, _react["default"].createElement(_index.AppCheckboxInput, {
        name: "charge",
        value: this.state.record.charge,
        handler: this.formHandler,
        label: "Charge for the card"
      }))))))), _react["default"].createElement(_index.ModalDialog, {
        show: this.state.showInfoModal,
        onClose: this.onCloseInfoModal.bind(this),
        shouldCloseOnOverlayClick: false,
        shouldCloseOnEsc: false
      }, _react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, _react["default"].createElement("p", null, "New password will be sent to user email."))));
    }
  }, {
    key: "onResetPassword",
    value: function onResetPassword(email) {
      var _this4 = this;

      new _UserModel["default"]().resetPassword(email).then(function () {
        _this4.setState({
          showInfoModal: true
        });

        setTimeout(function () {
          _this4.onCloseInfoModal();
        }, 3000);
      })["catch"](function () {});
    }
  }, {
    key: "onApproveUser",
    value: function onApproveUser(id) {
      var _this5 = this;

      new _UserModel["default"]().approve(id).then(function () {
        _this5.setState({
          redirect: true
        });
      })["catch"](function () {});
    }
  }, {
    key: "onRejectUser",
    value: function onRejectUser(id) {
      var _this6 = this;

      new _UserModel["default"]().reject(id).then(function () {
        _this6.setState({
          redirect: true
        });
      })["catch"](function () {});
    }
  }]);

  return CustomerBasicInfo;
}(_react.Component);

exports["default"] = CustomerBasicInfo;